import { Audio, Images, Tweens } from "@abcya/abcya_phaser";
import gameData from "../gameData";
import UIAssetKeys from "../UIAssetKeys";
import NounVerbs from "./NounVerbs";

export default class Hammer extends Phaser.GameObjects.Container
{
	constructor(scene, dir, ind, gatorContainer)
	{
		super(scene)

		this.dir = dir;
		this.ind = ind;

		this.gatorContainer = gatorContainer;

		this.hammer = null;
		this.cloud1 = null;
		this.cloud2 = null;
		this.sign = null;

		this.origAngle = null;

		this.cloud1 = this.scene.add.sprite(0,0, gameData.ss, "cloud");
		this.cloud1.setOrigin(0, 1);
		this.cloud1.setScale(0, 0);

		this.cloud2 = this.scene.add.sprite(0,0, gameData.ss, "cloud");
		this.cloud2.setOrigin(0, 1);
		this.cloud2.setScale(0, 0);

		this.add([this.cloud1, this.cloud2]);

		if(this.dir === "left"){
			this.cloud1.setPosition(gatorContainer.x - 50, gatorContainer.y + 125);
			this.cloud2.setPosition(gatorContainer.x - 50, gatorContainer.y + 125);
		} else {
			this.cloud1.setPosition(gatorContainer.x + 50, gatorContainer.y + 125);
			this.cloud2.setPosition(gatorContainer.x + 50, gatorContainer.y + 125);
		}

		this.hammer = this.scene.add.sprite(0,0, gameData.ss, "hammer");
		this.add(this.hammer);
		this.hammer.setOrigin(.9, .9);

		if(this.dir === "left"){
			this.hammer.setPosition(this.gatorContainer.x - 350, this.gatorContainer.y + 250);
			this.hammer.scaleX *=-1;
			this.origAngle = -70;
		} else {
			this.hammer.setPosition(this.gatorContainer.x + 350, this.gatorContainer.y + 250);
			this.origAngle = 70;
		}

		this.hammer.angle = this.origAngle;
		this.hammer.alpha = 0;

		Tweens.addTween(this.hammer, 250, {alpha: 1, angle: 0}, Phaser.Math.Easing.Quadratic.In, ()=>this.slammer())		

		if(gameData.currentScene === "TutorialScene" && this.ind === 0){
			this.createSign(true);
		}
	}

	createSign(isGood) {
		const randAngle = Phaser.Math.RND.between(-720, 720);
		this.sign = this.scene.add.container();

		let signs;
		let signBG;
		if(isGood){
			signs = ["Got It", "Great", "Super"];
			//ABCyaHelper.shuffleArray(signs);
			Phaser.Utils.Array.Shuffle(signs);

			signBG = Images.addImage(0, 0, UIAssetKeys._CorrectAnswer, this.sign).setOrigin(0);
			const signTxt = this.scene.add.image(0,0, gameData.ss, signs[0]);
			this.sign.add(signTxt);
			signTxt.setOrigin(.5, .5);
		}
		else {
			signs = ["IncorrectAnswer"];
			signBG = this.scene.add.image(0,0, gameData.ss, signs[0]);
			this.sign.add(signBG);
		}

		signBG.setOrigin(.5, .5);

		if(this.dir === "left"){
			this.sign.setPosition(this.gatorContainer.x - 100, this.gatorContainer.y);
		} else {
			this.sign.setPosition(this.gatorContainer.x + 50, this.gatorContainer.y);
		}

		this.sign.setScale(0, 0);
		this.sign.angle = randAngle;
	};

	slammer() {
		//console.log(this.gatorContainer.compareAnswer());
		if(this.gatorContainer.compareAnswer() === true){
			if(gameData.currentScene !== "TutorialScene") 
			{
				// make sure to do this before anything else, since some things depend on it in other classes (gatorReact for example)
				gameData.correctAnswers++;
			}
			this.createSign(true);
			this.gatorContainer.gatorReact(true);

			const randType = Phaser.Math.RND.between(1, 2);

			if(!gameData.mute) Audio.playOneShot("gator_hit_" + String(randType), this.scene);

			if(gameData.currentScene !== "TutorialScene") 
			{
				this.scene.navBar.tweenNoun();
			}

			Tweens.addTween(this.hammer, 250, {alpha:0, angle:this.origAngle, delay: 400}, Phaser.Math.Easing.Quadratic.Out);

			Tweens.addTween(this.sign, 1000, {angle:0}, Phaser.Math.Easing.Back.Out);
			Tweens.addTween(this.sign, 1250, {y:this.sign.y - 150}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.sign, 500, {alpha:0, delay: 750}, Phaser.Math.Easing.None);
			Tweens.addTween(this.sign, 1250, {scale: 1.25}, Phaser.Math.Easing.Elastic.Out);

			Tweens.addTween(this.cloud1, 1000, {scale: 1}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.cloud2, 1000, {scaleX: -1, scaleY: 1}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.cloud1, 1000, {alpha:{start: 1, to: 0}}, Phaser.Math.Easing.None);
			Tweens.addTween(this.cloud2, 1000, {alpha:{start: 1, to: 0}}, Phaser.Math.Easing.None);
			Tweens.addTween(this.cloud1, 1000, {x:this.cloud1.x + 125}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.cloud2, 1000, {x:this.cloud1.x - 125}, Phaser.Math.Easing.Quadratic.Out);

			gameData.rightAnswer = false;
		}
		else
		{
			//console.log("MISSING");
			this.createSign();
			this.gatorContainer.gatorReact();

			if(!gameData.mute) Audio.playOneShot("gator_miss_laugh", this.scene);

			this.logWrongAnswer();

			Tweens.addTween(this.hammer, 250, {alpha:0, angle:this.origAngle, delay: 400}, Phaser.Math.Easing.Quadratic.Out);

			Tweens.addTween(this.sign, 1000, {angle:0}, Phaser.Math.Easing.Back.Out);
			Tweens.addTween(this.sign, 1250, {y:this.sign.y - 150}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.sign, 500, {alpha:0, delay: 750}, Phaser.Math.Easing.None);
			Tweens.addTween(this.sign, 1250, {scale: 1.25}, Phaser.Math.Easing.Elastic.Out);

			Tweens.addTween(this.cloud1, 1000, {scale: 1}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.cloud2, 1000, {scaleX: -1, scaleY: 1}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.cloud1, 1000, {alpha:{start: 1, to: 0}}, Phaser.Math.Easing.None);
			Tweens.addTween(this.cloud2, 1000, {alpha:{start: 1, to: 0}}, Phaser.Math.Easing.None);
			Tweens.addTween(this.cloud1, 1000, {x:this.cloud1.x + 125}, Phaser.Math.Easing.Quadratic.Out);
			Tweens.addTween(this.cloud2, 1000, {x:this.cloud1.x - 125}, Phaser.Math.Easing.Quadratic.Out);
		}
	};

	logWrongAnswer(){
		if(gameData.currentScene !== "TutorialScene")
		{
			gameData.incorrectAnswers++;
		}
		gameData.wrongAnswers.push({noun:this.scene.navBar.nounText.text,
																		verb:this.gatorContainer.text.text,
																		right:this.getRightAnswer()});
	};

	getRightAnswer = function(){
		let right;
		//if the wrong verb is in singluar find it's partner is the opposite array
		if(NounVerbs.singleVerbs.indexOf(this.gatorContainer.text.text) !== -1) {
			right = NounVerbs.pluralVerbs[NounVerbs.singleVerbs.indexOf(this.gatorContainer.text.text)];
		} else {
			right = NounVerbs.singleVerbs[NounVerbs.pluralVerbs.indexOf(this.gatorContainer.text.text)];
		}

		return right;
	};

	cleanUp(){
		this.cloud1.destroy();

		this.cloud2.destroy();

		this.sign.destroy();

		this.hammer.destroy();

	};
}